import { assign } from 'xstate5';
import type { MixedDressingDetails } from '@sg/graphql-schema';

import {
  checkIfMixableDressingIngredient,
  generateMixedDressingDetailsFactory,
} from '../../helpers';
import type { CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Generate mixed dressing details based on the active modifications.
 */
export const generateMixedDressingDetails: CustomizationMachineAction = assign(
  (args) => {
    const {
      modifications,
      defaultDressingWeight,
      mixedDressingDetails: currentMixedDressingDetails,
    } = args.context;

    const activeModifications = modifications?.active;

    if (!activeModifications) {
      return {};
    }

    const mixableDressings = activeModifications.filter(checkIfMixableDressingIngredient); // prettier-ignore
    const hasMultipleMixableDressings = mixableDressings.length > 1;
    const generateDressingDetails = generateMixedDressingDetailsFactory({
      hasMultipleMixableDressings,
      currentMixedDressingDetails,
      defaultWeight: defaultDressingWeight,
    });
    const mixedDressingDetails = mixableDressings.map(generateDressingDetails).filter(Boolean) as MixedDressingDetails[]; // prettier-ignore

    return {
      mixedDressingDetails,
    };
  },
);
